import React from 'react'
import { css } from '@emotion/react'

const Footer = () => {
  return (
    <footer css={footerStyle}>
      <p css={copyStyle}>Copyright © since 1998 DMM All Rights Reserved.</p>
    </footer>
  )
}

const footerStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px 0;
  background-color: #242424;
  margin-top: auto;
`

const copyStyle = css`
  font-size: 12px;
  color: #fff;
  text-align: center;
`

export default Footer
